export default function Solutions() {
  const handleWhatsAppClick = () => {
    if (typeof window !== "undefined" && typeof (window as any).gtag_report_conversion === "function") {
      (window as any).gtag_report_conversion();
    }
    window.open(
      "https://wa.me/5512997213362?text=Ol%C3%A1%20Dr.%20Gabriel%2C%20vim%20pelo%20site%20e%20quero%20analisar%20meu%20caso%20de%20bloqueio%20judicial",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const steps = [
    {
      number: "01",
      icon: "ri-search-2-line",
      title: "Análise do processo que gerou o bloqueio",
      desc: "Identificação da natureza do processo, da parte credora, do valor bloqueado e das irregularidades presentes.",
    },
    {
      number: "02",
      icon: "ri-bank-line",
      title: "Verificação da origem dos valores bloqueados",
      desc: "Avaliação se os valores têm natureza salarial, previdenciária ou outro tipo que pode ser protegido por lei.",
    },
    {
      number: "03",
      icon: "ri-scales-3-line",
      title: "Identificação de impenhorabilidade ou excesso",
      desc: "Verificação se o bloqueio viola direitos de impenhorabilidade ou se o valor é desproporcional à dívida.",
    },
    {
      number: "04",
      icon: "ri-alert-line",
      title: "Análise de nulidades e teses de defesa",
      desc: "Revisão de vícios no crédito tributário, prescrição, irregularidades formais e outras teses aplicáveis.",
    },
    {
      number: "05",
      icon: "ri-file-paper-line",
      title: "Protocolo da medida jurídica cabível",
      desc: "Elaboração e protocolo das peças processuais adequadas — pedido de desbloqueio, exceção de pré-executividade, embargos ou outros instrumentos.",
    },
    {
      number: "06",
      icon: "ri-eye-line",
      title: "Acompanhamento jurídico do caso",
      desc: "Monitoramento das decisões, cumprimento de prazos e comunicação transparente durante todo o processo.",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3">
            Metodologia de atuação
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Como funciona nossa atuação
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            Da análise inicial ao acompanhamento processual, cada etapa é conduzida com rigor técnico e atenção ao seu caso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative bg-gray-50 rounded-2xl p-7 border border-gray-100 hover:border-amber-300 transition-all duration-200">
              <div className="flex items-start gap-4 mb-4">
                <div className="text-5xl font-black text-amber-100 leading-none select-none shrink-0">
                  {step.number}
                </div>
                <div className="w-10 h-10 flex items-center justify-center bg-amber-500 rounded-lg shrink-0 mt-1">
                  <i className={`${step.icon} text-white text-lg`}></i>
                </div>
              </div>
              <h3 className="text-gray-900 font-semibold text-sm mb-3 leading-snug">
                {step.title}
              </h3>
              <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="bg-gray-900 rounded-3xl p-8 md:p-12 text-center text-white">
          <p className="text-amber-400 text-xs font-bold uppercase tracking-widest mb-4">
            Não espere o problema aumentar
          </p>
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Clique abaixo e fale agora com o advogado pelo WhatsApp
          </h3>
          <p className="text-gray-400 text-sm mb-8 max-w-lg mx-auto">
            Quanto mais rápido o caso for analisado, maiores as chances de identificar medidas jurídicas eficazes.
          </p>
          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-500 text-white px-10 py-4 rounded-full text-base font-semibold transition-all duration-300 cursor-pointer transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar com o Advogado Agora
          </button>
        </div>
      </div>
    </section>
  );
}
